<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.from") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="txtStudentCodeFrom"
                                  @keypress="handleSearchStudentFromKey($event)"
                                />
                                <button
                                  class="btn btn-primary btn-lg"
                                  type="button"
                                  @click="openDialogSearch('from')"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameFrom"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentFrom()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.to") }}
                      {{ $t("messages.general.identity") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="txtStudentCodeTo"
                                  @keypress="handleSearchStudentToKey($event)"
                                />
                                <button
                                  class="btn btn-primary btn-lg"
                                  type="button"
                                  @click="openDialogSearch('to')"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              v-model="txtStudentNameTo"
                              disabled
                            />
                            <button
                              class="btn btn-danger btn-lg"
                              type="button"
                              @click="clearStudentTo()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.idCondition") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Condition
                      :onChanged="onSelCondiChanged"
                      :selectedVal="selCondi"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    type="button"
                    class="btn btn-primary btn-lg"
                    @click="handleSearchConfirmResult()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-light btn-lg"
                    @click="handleClearScreen()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTable.sortBy"
              :sort-desc.sync="bTable.sortDesc"
              :items="bTable.items"
              :fields="bTable.fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTable.items.length"
                  v-model="currentPage"
                  :per-page="perPage"
                />
                <div
                  v-if="bTable.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPage > 1
                        ? (currentPage - 1) * perPage + 1
                        : currentPage
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPage * perPage > bTable.items.length
                        ? bTable.items.length
                        : currentPage * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTable.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTable.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(action)="data">
                <v-btn text icon @click="goTo(data.item, data.index, 'view')">
                  <v-icon @click="goTo(data.item, data.index, 'view')"
                    >search</v-icon
                  >
                </v-btn>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTable.items.length"
                    v-model="currentPage"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTable.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPage > 1
                          ? (currentPage - 1) * perPage + 1
                          : currentPage
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPage * perPage > bTable.items.length
                          ? bTable.items.length
                          : currentPage * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTable.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTable.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </div>
      </div>
      <div class="card" v-if="isEdit">
        <div class="card-header">
          <v-icon color="pink">edit</v-icon>
          <h4>{{ $t("messages.general.manageData") }}</h4>
        </div>
        <v-card width="100%">
          <v-row>
            <v-col
              cols="10"
              style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
            >
              <p style="color: red; margin: 0">*</p>
            </v-col>
            <v-col
              style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
            >
              <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
            </v-col>
          </v-row>
        </v-card>
        <form>
          <div class="information-block">
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.academicYear") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.ACADYEAR }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.semester") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.SEMESTER }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.educationLvl") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selLvl }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 16em;">
                    <div>{{ $t("messages.general.nameStu") }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div>{{ selected.STUDENTNAME }}</div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                  <div class="col no-margin-padding">
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="form-row flex-column justify-content-center align-items-center mt-5"
          >
            <div class="form-group">
              <div class="form-inline">
                <button
                  type="button"
                  class="btn btn-light btn-lg"
                  @click="goBack()"
                >
                  {{ $t("messages.general.backhome") }}</button
                >&nbsp;&nbsp;&nbsp;
              </div>
            </div>
          </div>
          <v-card style="height: 350px; overflowX: auto; position: relative;">
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableConditionStudent.sortBy"
              :sort-desc.sync="bTableConditionStudent.sortDesc"
              :items="bTableConditionStudent.items"
              :fields="bTableConditionStudent.fields"
              :per-page="perPage"
              :current-page="currentPageStudent"
              style="position: relative; overflowY: hidden; padding-bottom: 55px"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableConditionStudent.items.length"
                  v-model="currentPageStudent"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableConditionStudent.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageStudent > 1
                        ? (currentPageStudent - 1) * perPage + 1
                        : currentPageStudent
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageStudent * perPage >
                        bTableConditionStudent.items.length
                        ? bTableConditionStudent.items.length
                        : currentPageStudent * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{
                    Number(bTableConditionStudent.items.length).toLocaleString()
                  }}
                </div>
                <div
                  v-if="bTableConditionStudent.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{
                    Number(bTableConditionStudent.items.length).toLocaleString()
                  }}
                </div>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -7px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableConditionStudent.items.length"
                    v-model="currentPageStudent"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableConditionStudent.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageStudent > 1
                          ? (currentPageStudent - 1) * perPage + 1
                          : currentPageStudent
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageStudent * perPage >
                          bTableConditionStudent.items.length
                          ? bTableConditionStudent.items.length
                          : currentPageStudent * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(
                        bTableConditionStudent.items.length
                      ).toLocaleString()
                    }}
                  </div>
                  <div
                    v-if="bTableConditionStudent.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{
                      Number(
                        bTableConditionStudent.items.length
                      ).toLocaleString()
                    }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </form>
      </div>
    </div>
    <v-dialog v-model="dialogSearch" hide-overlay scrollable max-width="80%">
      <v-card tile>
        <v-toolbar flat dense>
          <v-icon>search</v-icon>
          <v-toolbar-title>{{
            $t("messages.general.studentListName")
          }}</v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogSearch = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark>
          <form>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.identity") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgSearchStudentId"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.fullname") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div>
                      <input
                        v-model="dlgSearchStudentName"
                        type="text"
                        class="form-control col mr-2"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultySearchChanged"
                      :selectedVal="selFacultySearch"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.department") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Department
                      :onChanged="onSelDepartmentSearchChanged"
                      :facultyid="selFacultySearch"
                      :selectedVal="selDepartmentSearch"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label>{{ $t("messages.general.educationLvl") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlSearchChanged"
                      :selectedVal="selLvlSearch"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.from") }}
                      {{ $t("messages.general.studentStatus") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <StudentStatus
                      :onChanged="onSelStudentStatusSearchFromChanged"
                      :selectedVal="selStudentStatusSearchFrom"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 10em;">
                    <label
                      >{{ $t("messages.general.to") }}
                      {{ $t("messages.general.studentStatus") }}</label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <StudentStatus
                      :onChanged="onSelStudentStatusSearchToChanged"
                      :selectedVal="selStudentStatusSearchTo"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    @click="handleSearchStudentCode()"
                  >
                    {{ $t("messages.general.search") }}</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="cleartSearchStudentCode()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
          <v-card>
            <b-table
              bordered
              hover
              small
              responsive
              caption-top
              class="table table-striped text-center"
              :sort-by.sync="bTableSearch.sortBy"
              :sort-desc.sync="bTableSearch.sortDesc"
              :items="bTableSearch.items"
              :fields="bTableSearch.fields"
              :per-page="perPage"
              :current-page="currentPageSearch"
            >
              <template slot="table-caption">
                <div class="float-left">
                  <b class="mr-2">{{
                    $t("messages.general.table.paginationinfo")
                  }}</b>
                  <b-form-select
                    v-model="perPage"
                    :options="perPageOptions"
                    size="sm"
                    style="width:70px"
                  />
                </div>
                <b-pagination
                  class="float-right"
                  size="sm"
                  :total-rows="bTableSearch.items.length"
                  v-model="currentPageSearch"
                  :per-page="perPage"
                />
                <div
                  v-if="bTableSearch.items.length > 0"
                  class="float-right data-table-page-info"
                >
                  {{
                    Number(
                      currentPageSearch > 1
                        ? (currentPageSearch - 1) * perPage + 1
                        : currentPageSearch
                    ).toLocaleString()
                  }}
                  -
                  {{
                    Number(
                      currentPageSearch * perPage > bTableSearch.items.length
                        ? bTableSearch.items.length
                        : currentPageSearch * perPage
                    ).toLocaleString()
                  }}
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableSearch.items.length).toLocaleString() }}
                </div>
                <div
                  v-if="bTableSearch.items.length <= 0"
                  class="float-right data-table-page-info"
                >
                  0 - 0
                  {{ $t("messages.general.fromRecords") }}
                  {{ Number(bTableSearch.items.length).toLocaleString() }}
                </div>
              </template>

              <template v-slot:cell(STUDENTID)="data">
                <a
                  @click="handleSelectStudent(data.item, data.index)"
                  style="text-decoration: underline;"
                >
                  {{ data.item.STUDENTID }}
                </a>
              </template>

              <template slot="table-caption">
                <div
                  style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                >
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableSearch.items.length"
                    v-model="currentPageSearch"
                    :per-page="perPage"
                    style="padding-top: 10px"
                  />
                  <div
                    v-if="bTableSearch.items.length > 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    {{
                      Number(
                        currentPageSearch > 1
                          ? (currentPageSearch - 1) * perPage + 1
                          : currentPageSearch
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageSearch * perPage > bTableSearch.items.length
                          ? bTableSearch.items.length
                          : currentPageSearch * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableSearch.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableSearch.items.length <= 0"
                    class="float-right data-table-page-info"
                    style="padding-top: 14px"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableSearch.items.length).toLocaleString() }}
                  </div>
                </div>
              </template>
            </b-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmSuccess" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="light-green accent-3">
          <v-icon color="light-green darken-2">fa-check</v-icon>
          <v-toolbar-title style="color: green;"
            >&nbsp;{{
              $t("messages.reqRegister.confirmPopupText")
            }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogConfirmSuccess = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="green accent-1">
          <br />
          <span v-html="successText" style="color: green;">{{
            successText
          }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogError" max-width="600px">
      <v-card tile>
        <v-toolbar flat dense color="red darken-3">
          <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
          <v-toolbar-title style="color: #ffebee;"
            >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
          <v-toolbar-items>
            <v-btn icon @click="dialogError = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text dark color="red accent-1">
          <br />
          <span style="color: red;" v-html="errorText">{{ errorText }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "../components/Dropdown/AcademicYear";
import Semester from "../components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Department from "@/components/Dropdown/Department.vue";
import StudentStatus from "@/components/Dropdown/StudentStatus";
import MasterDataProvider from "@/services/masterData_provider";
import EnrollProvider from "@/services/enroll_provider";
import Condition from "@/components/Dropdown/Condition.vue";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "chkHConditionCancelCtrlEnroll",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Department,
    Condition,
    StudentStatus,
  },
  data() {
    return {
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selCondi: -1,
      selSection: "00",
      courseCode: "",
      courseName: "",
      sections: [],
      items: [],
      mode: "",
      studentCodeMode: "",
      dlgSearchStudentId: "",
      dlgSearchStudentName: "",
      selFacultySearch: 0,
      selDepartmentSearch: 0,
      selLvlSearch: 3,
      selStudentStatusSearchFrom: 0,
      selStudentStatusSearchTo: 0,
      studentUnapproveList: [],
      txtStudentCodeFrom: "",
      txtStudentNameFrom: "",
      txtStudentCodeTo: "",
      txtStudentNameTo: "",
      dialogSearch: false,
      bTable: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "action",
            label: "",
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "STUDENTNAME",
            label: this.$t("messages.general.student"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp col-250",
            sortable: true,
          },
          {
            key: "ERRORID",
            label: this.$t("messages.general.idCondition"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      bTableConditionStudent: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [],
      },
      bTableSearch: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "STUDENTID",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "FULLNAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.faculty"),
            thClass: "align-middle",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "DEPARTMENTGROUPNAME",
            label: this.$t("messages.general.department"),
            thClass: "align-middle",
            sortable: true,
          },
          {
            key: "LEVELNAME",
            label: this.$t("messages.general.educationLvl"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
      perPageOptions: [
        { value: 10, text: 10 },
        { value: 50, text: 50 },
        { value: 100, text: 100 },
        { value: 500, text: 500 },
        { value: 1000, text: 1000 },
        { value: 2000, text: 2000 },
        { value: 3000, text: 3000 },
      ],
      perPage: 100,
      perPageStudentReg: 50,
      currentPage: 1,
      currentPageProgram: 1,
      searched: false,
      selected: false,
      selectedIdx: 0,
      isEdit: false,
      isSpecial: false,
      selectedDetail: false,
      dlgCourseCode: "",
      dlgCourseName: "",
      selDepartmentCourse: 0,
      selFacultyCourse: 0,
      selectedClsId: 0,
      dialogConfirmSuccess: false,
      successText: "",
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      confirmType: 0,
      totalRequest: 0,
      totalConfirm: "",
      //isStudentSelect: true,
      infoFormStatus: 2,
      regStatus: 0,
      dialogStudents: false,
      currentPageStudentReg: 1,
      studentIdList: [],
      studentList: [],
      tmpStudentList: [],
      tmpStudentIdList: [],
      totalSumSeat: "",
      // isEditTotalSumSeat: false,
      dialogRandom: false,
      randomType: "AC",
      totalConfirmDisabled: false,
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.selSection = "00";
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
      this.getSections();
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
      this.getSections();
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelCondiChanged(event) {
      this.selCondi = event.target.value;
    },
    onSelSectionChanged(event) {
      this.selSection = event.target.value;
    },
    onSelFacultyCourseChanged() {
      this.selFacultyCourse = parseInt(event.target.value);
    },
    onSelDepartmentCourseChanged(event) {
      this.selDepartmentCourse = parseInt(event.target.value);
    },
    onSelFacultySearchChanged(event) {
      this.selFacultySearch = parseInt(event.target.value);
    },
    onSelDepartmentSearchChanged(event) {
      this.selDepartmentSearch = parseInt(event.target.value);
    },
    onSelLvlSearchChanged(event) {
      this.selLvlSearch = parseInt(event.target.value);
    },
    onSelStudentStatusSearchFromChanged(event) {
      this.selStudentStatusSearchFrom = parseInt(event.target.value);
    },
    onSelStudentStatusSearchToChanged(event) {
      this.selStudentStatusSearchTo = parseInt(event.target.value);
    },
    handleSelectStudent(data, idx) {
      this.searchSelIdx = idx;
      if (this.studentCodeMode == "from") {
        this.txtStudentCodeFrom = data.STUDENTCODE;
        this.txtStudentNameFrom = data.FULLNAME;
      } else {
        this.txtStudentCodeTo = data.STUDENTCODE;
        this.txtStudentNameTo = data.FULLNAME;
      }
      this.dialogSearch = false;
    },
    async handleSearchStudentKey(code, mode) {
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvlSearch,
          lang: this.currentLang,
        },
      };
      console.log("mode handleSearchStudentKey", mode);
      params.request.studentcode = code;
      this.studentCodeMode = mode;
      this.togglePreLoader(true);
      const result = await enrollProvider.searchStudentCode(params);
      this.togglePreLoader(false);
      console.log("result handleSearchStudentKey", result);
      if (
        mode == "from" &&
        result.length > 0 &&
        (result.length == 1 || result[0].STUDENTCODE == code)
      ) {
        this.txtStudentCodeFrom = result[0].STUDENTCODE;
        this.txtStudentNameFrom = `${result[0].PREFIXNAME}${result[0].STUDENTNAME} ${result[0].STUDENTSURNAME}`;
      } else if (
        mode == "to" &&
        result.length > 0 &&
        (result.length == 1 || result[0].STUDENTCODE == code)
      ) {
        this.txtStudentCodeTo = result[0].STUDENTCODE;
        this.txtStudentNameTo = `${result[0].PREFIXNAME}${result[0].STUDENTNAME} ${result[0].STUDENTSURNAME}`;
      } else {
        this.dlgSearchStudentId =
          mode == "from" ? this.txtStudentCodeFrom : this.txtStudentCodeTo;
        this.dialogSearch = true;
        this.handleSearchStudentCode();
      }
    },
    async openDialogSearch(mode) {
      this.togglePreLoader(true);
      if (this.txtStudentCodeFrom != "" && mode == "from") {
        const result = await this.handleSearchStudentKey(
          this.txtStudentCodeFrom,
          mode
        );
        if (result) {
          this.txtStudentCodeFrom = result.code;
          this.txtStudentNameFrom = result.name;
        } else {
          this.txtStudentNameFrom = "";
        }
      } else if (this.txtStudentCodeTo != "" && mode == "to") {
        const result = await this.handleSearchStudentKey(
          this.txtStudentCodeTo,
          mode
        );
        if (result) {
          this.txtStudentCodeTo = result.code;
          this.txtStudentNameTo = result.name;
        } else {
          this.txtStudentNameTo = "";
        }
      } else {
        this.cleartSearchStudentCode();
        this.dialogSearch = true;
        this.studentCodeMode = mode;
      }
      this.togglePreLoader(false);
    },
    cleartSearchStudentCode() {
      this.studentCodeMode = "";
      this.dlgSearchStudentId = "";
      this.dlgSearchStudentName = "";
      this.selFacultySearch = 0;
      this.selDepartmentSearch = 0;
      this.selLvlSearch = 3;
      this.selStudentStatusSearchFrom = 0;
      this.selStudentStatusSearchTo = 0;
      this.bTableSearch.items = [];
    },
    async handleSearchStudentFromKey(event) {
      if (event.charCode == 13 && this.txtStudentCodeFrom != "") {
        this.handleSearchStudentKey(this.txtStudentCodeFrom, "from");
      }
    },
    async handleSearchStudentToKey(event) {
      if (event.charCode == 13 && this.txtStudentCodeTo != "") {
        this.handleSearchStudentKey(this.txtStudentCodeTo, "to");
      }
    },
    clearStudentFrom() {
      this.txtStudentCodeFrom = "";
      this.txtStudentNameFrom = "";
    },
    clearStudentTo() {
      this.txtStudentCodeTo = "";
      this.txtStudentNameTo = "";
    },
    handleClrCourse() {
      this.courseCode = "";
      this.courseName = "";
      this.sections = [];
    },
    async handleSelectClass(item) {
      if (item && item.COURSECODE != null) {
        this.courseCode = item.COURSECODE;
        this.courseName = item.COURSENAME;
        await this.getSections();
      }
    },
    async getSections() {
      if (this.selYear != 0 && this.selSemester != 0 && this.courseCode != "") {
        this.togglePreLoader(true);
        const data = await masterDataProvider.getSection({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            coursecode: this.courseCode,
            lang: this.currentLang,
          },
        });
        this.sections = data;
        this.togglePreLoader(false);
      }
    },
    async handleSearchConfirmResult() {
      if (this.selYear != 0 && this.selSemester != 0 && this.selLvl != -1) {
        this.togglePreLoader(true);
        const result = await enrollProvider.adjustconditionlog({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            levelid: this.selLvl,
            studentidfrom: this.txtStudentCodeFrom,
            studentidto: this.txtStudentCodeTo,
            errorid: this.selCondi == -1 ? "" : this.selCondi,
            lang: this.currentLang,
          },
        });
        this.bTable.items = [];
        if (result.length > 0) {
          this.searched = true;
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTable.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);
      }
    },
    async getReqConfirmDetail() {
      if (this.selected) {
        this.togglePreLoader(true);
        const studentArr = this.selected.STUDENTNAME.split(" ");
        const result = await enrollProvider.adjustconditionlogdetail({
          token: this.token,
          request: {
            acadyear: this.selYear,
            semester: this.selSemester,
            studentid: studentArr.length > 0 ? studentArr[0] : "0",
            lang: this.currentLang,
          },
        });
        this.togglePreLoader(false);
        if (result.length > 0) {
          this.selectedDetail = result[0];
          this.bTableConditionStudent.items = [];
          const temp = result.map((r, index) => {
            return {
              rowNumber: index + 1,
              ...r,
            };
          });
          this.bTableConditionStudent.items = temp;
          this.isEdit = true;
        }
      }
    },
    async handleSearchStudentCode() {
      this.togglePreLoader(true);
      const params = {
        token: this.token,
        request: {
          levelid: this.selLvlSearch,
          lang: this.currentLang,
        },
      };
      if (this.dlgSearchStudentId != 0) {
        params.request.studentcode = this.dlgSearchStudentId;
      }
      if (this.dlgSearchStudentName != "") {
        params.request.studentname = this.dlgSearchStudentName;
      }
      if (this.selFacultySearch != 0) {
        params.request.facultyid = this.selFacultySearch;
      }
      if (this.selDepartmentSearch != 0) {
        params.request.departmentid = this.selDepartmentSearch;
      }
      if (this.selStudentStatusSearchFrom != 0) {
        params.request.studentstatusfrom = this.selStudentStatusSearchFrom;
      }
      if (this.selStudentStatusSearchTo != 0) {
        params.request.studentstatusto = this.selStudentStatusSearchTo;
      }
      const result = await enrollProvider.searchStudentCode(params);
      this.bTableSearch.items = [];
      if (result.length > 0) {
        let idx = 0;
        if (!result[idx].hasOwnProperty("ERR_DESC")) {
          result.map((d) => {
            d.rowNumber = idx + 1;
            d.FULLNAME = `${d.PREFIXNAME} ${d.STUDENTNAME} ${d.STUDENTSURNAME}`;
            this.bTableSearch.items.push(d);
            idx++;
          });
        }
      }
      this.togglePreLoader(false);
    },
    handleClearScreen() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selSection = "00";
      this.handleClrCourse();
      this.selected = false;
      this.searched = false;
      this.selectedIdx = 0;
      this.bTable.items = [];
    },
    goTo(item, index, mode) {
      this.totalConfirm = 0;
      this.selected = item;
      this.selectedIdx = index;
      console.log("item", item);
      this.getReqConfirmDetail();
      console.log("goto mode", mode);
      this.mode = mode;
      this.bTableConditionStudent.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "ERRORID",
          label: this.$t("messages.general.idCondition"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "ERRORSTRING",
          label: this.$t("messages.general.condition"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "BYTEDES",
          label: this.$t("messages.general.periodStu"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "UPDATEUSER",
          label: this.$t("messages.general.cancelBy"),
          thClass: "align-middle",
          tdClass: "text-left col-200",
          sortable: true,
        },
        {
          key: "TIMEDATE",
          label: this.$t("messages.general.cancelTime"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "STATUS",
          label: this.$t("messages.general.status"),
          thClass: "align-middle",
          tdClass: "text-center",
          sortable: true,
        },
      ];
      this.isEdit = true;
    },
    goBack() {
      this.totalConfirm = 0;
      this.selected = false;
      this.selectedIdx = 0;
      this.selectedDetail = false;
      this.isEdit = false;
      this.dialogRandom = false;
      this.handleSearchConfirmResult();
      this.mode = "";
    },
    async handleCourseSearch() {
      if (this.dlgCourseCode != "" || this.dlgCourseName != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.searchCourse({
          token: this.token,
          request: {
            coursecode: this.dlgCourseCode,
            coursename: this.dlgCourseName,
            facultyid: this.selFacultyCourse,
            departmentid: this.selDepartmentCourse,
            lang: this.currentLang,
          },
        });
        this.bTableProgram.items = [];
        if (result.length > 0) {
          let idx = 0;
          result.map((d) => {
            d.rowNumber = idx + 1;
            this.bTableProgram.items.push(d);
            idx++;
          });
        }
        this.togglePreLoader(false);
      } else {
        this.dialogError = true;
        this.errorText = this.$t("messages.general.programCodeNameReq");
      }
    },
  },
  watch: {
    currentLang() {
      this.bTableSearch.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "STUDENTID",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "FULLNAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.faculty"),
          thClass: "align-middle",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "DEPARTMENTGROUPNAME",
          label: this.$t("messages.general.department"),
          thClass: "align-middle",
          sortable: true,
        },
        {
          key: "LEVELNAME",
          label: this.$t("messages.general.educationLvl"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      this.bTableConditionStudent.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "ERRORID",
          label: this.$t("messages.general.idCondition"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "ERRORSTRING",
          label: this.$t("messages.general.condition"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "BYTEDES",
          label: this.$t("messages.general.periodStu"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "UPDATEUSER",
          label: this.$t("messages.general.cancelBy"),
          thClass: "align-middle",
          tdClass: "text-left  col-200",
          sortable: true,
        },
        {
          key: "TIMEDATE",
          label: this.$t("messages.general.cancelTime"),
          thClass: "align-middle",
          tdClass: "text-left",
          sortable: true,
        },
        {
          key: "STATUS",
          label: this.$t("messages.general.status"),
          thClass: "align-middle",
          tdClass: "text-center",
          sortable: true,
        },
      ];
      this.bTable.fields = [
        {
          key: "action",
          label: "",
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "STUDENTNAME",
          label: this.$t("messages.general.student"),
          thClass: "align-middle",
          tdClass: "text-left text-nowarp col-250",
          sortable: true,
        },
        {
          key: "ERRORID",
          label: this.$t("messages.general.idCondition"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
      if (this.searched) {
        this.handleSearchConfirmResult();
      }
      this.getReqConfirmDetail();
    },
  },
};
</script>
